import { Button, Flex } from '@radix-ui/themes';
import { EB } from 'components/layout/error-boundary';
import { FormProvider } from 'contexts/form';
import { TableToolbarDef } from 'interfaces/table';
import { Fragment, useMemo } from 'react';

export const CommonTableToolbar = (props: TableToolbarDef) => {
  const safeControls = props.toolbarControls ?? [];

  const safeActions = useMemo(
    () => props.toolbarActions?.filter((item) => !item.hidden) ?? [],
    [props.toolbarActions]
  );

  if (safeControls.length + safeActions.length === 0) {
    // nothing to render
    return null;
  }

  return (
    <EB>
      <Flex gap="4" align="center">
        {/* start - toolbarControls */}
        <Flex gap="2" align="center" flexGrow="1" pt="1">
          <FormProvider defaultData={{}}>
            {safeControls.map((item, i) => (
              <Fragment key={`control-${i}`}>{item}</Fragment>
            ))}
          </FormProvider>
        </Flex>

        {/* end - toolbarActions */}
        <Flex gap="2" align="center">
          {safeActions.map((item, i) => (
            <Button key={`action-${i}`} variant="soft" onClick={item.onClick}>
              {item.label}
            </Button>
          ))}
        </Flex>
      </Flex>
    </EB>
  );
};
